import { useEffect, useState } from 'react';

import ReactDOM from 'react-dom';

import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

import { Checkbox } from '@material-ui/core';

import './suneditor_dark_theme.sass';

export default function WSIGEditor({
  content,
  onChange,
  addFullSizeBtn = false,
  fullSizeCheked = false,
  editorButtonList = [],
  onFullSizeChange,
  ...rest
}) {
  const FullSizeImage = ({ initState = false, onFullSizeChange = () => {} }) => {
    const [checked, setChecked] = useState(initState);
    const handleChange = (val) => {
      setChecked(val);
      onFullSizeChange(val);
    };

    return (
      <>
        <Checkbox color="secondary" checked={checked} onChange={(e) => handleChange(e.target.checked)} />
        <span className="se-tooltip-inner">
          <span className="se-tooltip-text">FullSize</span>
        </span>
      </>
    );
  };

  useEffect(() => {
    if (addFullSizeBtn) {
      const allWithClass = Array.from(document.querySelectorAll('.se-btn-group'));
      var el = document.createElement('div');
      el.id = 'FullSizeImage';
      el.className = 'se-tooltip';
      allWithClass[1].append(el);
      ReactDOM.render(
        <FullSizeImage initState={fullSizeCheked} onFullSizeChange={onFullSizeChange} />,
        document.getElementById('FullSizeImage'),
      );
    }
  }, []);

  return (
    <SunEditor
      defaultValue={content}
      setDefaultStyle="color: #cecece; background-color: #212121;"
      onChange={onChange}
      setOptions={{
        height: 'unset',
        minHeight: 300,
        maxHeight: window.innerHeight - 500,
        buttonList: editorButtonList.length ? editorButtonList : buttonList.complex,
        font: [
          'Roboto',
          'Arial',
          'Comic Sans MS',
          'Courier New',
          'Impact',
          'Georgia',
          'tahoma',
          'Trebuchet MS',
          'Verdana',
        ],
      }}
      {...rest}
    />
  );
}
